import { Button, Col, DatePicker, Form, Input, Modal, Row, Select } from 'antd';
import { FC, useState } from 'react';
import { RiCloseFill } from 'react-icons/ri';
import {
  CreateRentDto,
  AssetResponse,
} from '../../../api/client/data-contracts';
import {
  useAllCustomers,
  useCustomerAddresses,
} from '../customers/useCustomers';
import { useRents } from './useRents';
import { FormattedMessage, useIntl } from 'react-intl';
import { Moment } from 'moment';
import { getAddressString } from './update-rent-customer-address';

//dayjs.extend(badMutable);
export interface Props {
  open: boolean;
  handleCancel: () => void;
}

interface FormModel {
  customer: string;
  asset: number;
  delliveryAddress: string;
  startDate: string;
  endDate: string;
  paymentValue: number;
  rentPeriod: [startDate: Moment, endDate: Moment];
  notes: string;
}

const convertFormModelToCreateRentDto = (
  formModel: FormModel,
): CreateRentDto => {
  console.log(formModel);
  const createRentDto: CreateRentDto = {
    customer: formModel.customer,
    delliveryAddress: formModel.delliveryAddress || null,
    startDate: formModel.rentPeriod[0]
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString(),
    endDate: formModel.rentPeriod[1]
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .toISOString(),

    notes: formModel.notes || null,
  };

  return createRentDto;
};

export function getAssetString(asset: AssetResponse) {
  const assetString = `${asset.serialNumber}`;
  return assetString;
}
const RentsForm: FC<Props> = (props) => {
  const { createRent } = useRents();
  const handleConfirm = (values: FormModel) => {
    const createRentDto = convertFormModelToCreateRentDto(values);
    createRent(createRentDto);
    form.resetFields();
    props.handleCancel();
  };

  const [form] = Form.useForm();

  const initialValues = {};

  const [selectedCustomer, setSelectedCustomer] = useState('');
  function handleCustomerChanged(customerId: string) {
    if (customerId !== selectedCustomer) {
      form.setFieldValue('delliveryAddress', undefined);
    }
    setSelectedCustomer(customerId);
  }
  const { customersQuery } = useAllCustomers();
  const { addressesQuery } = useCustomerAddresses(selectedCustomer);

  const intl = useIntl();
  return (
    <Modal
      title={<h5 className='hp-mb-0'>Criar Aluguer</h5>}
      width={416}
      open={props.open}
      onCancel={props.handleCancel}
      footer={<></>}
      closeIcon={
        <RiCloseFill
          className='remix-icon hp-text-color-black-100 hp-text-color-dark-0'
          size={24}
        />
      }
    >
      <Form
        onFinish={handleConfirm}
        form={form}
        layout='vertical'
        name='basic'
        initialValues={initialValues}
      >
        <Form.Item required label='Cliente' name='customer'>
          <Select
            placeholder='Selecione uma cliente'
            onChange={handleCustomerChanged}
            optionFilterProp='label'
            showSearch
            options={
              customersQuery.data &&
              customersQuery.data.map((customer) => ({
                value: customer.id,
                label: customer.description,
              }))
            }
            onSearch={console.log}
          />
        </Form.Item>
        <Form.Item label='Morada de entrega' name='delliveryAddress'>
          <Select
            disabled={!selectedCustomer}
            placeholder='Selecione a morada de entrega'
          >
            {addressesQuery.data &&
              addressesQuery.data
                .filter((address) => address.isDelliveryAddress)
                .map((address) => (
                  <Select.Option value={address.id}>
                    {getAddressString(address)}
                  </Select.Option>
                ))}
          </Select>
        </Form.Item>

        <Form.Item required label='Período do aluger' name='rentPeriod'>
          <DatePicker.RangePicker />
        </Form.Item>
        <Form.Item label='Notas' name='notes'>
          <Input.TextArea rows={3} />
        </Form.Item>

        <Row>
          <Col md={12} span={24} className='hp-pr-sm-0 hp-pr-12'>
            <Button block type='primary' htmlType='submit'>
              <FormattedMessage id='create' />
            </Button>
          </Col>

          <Col md={12} span={24} className='hp-mt-sm-12 hp-pl-sm-0 hp-pl-12'>
            <Button block onClick={props.handleCancel}>
              {intl.formatMessage({ id: 'cancel' })}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default RentsForm;
